export default {
  notificationInsufficientTitle:{
    en: 'Insufficient balance',
    ja: 'バランス不足'

  },
}
